import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { setAppMode, setIsFetchPaymentMethodEnabled } from './AppModeState.actions';
import { AppMode } from './AppModeState.types';
import { doFireStatusUpdate } from '../../utils/CallbackUtils';
import { StatusTypes, PaymentMethodsCommandNames, SharedCommandNames } from '@chegg/commerce-utils';
import { Component } from '../../constants/CallbackConstants';
export var setAppModeListener = function setAppModeListener(middleware) {
  return middleware.startListening({
    actionCreator: setAppMode,
    effect: function () {
      var _effect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
        var payload, getState, dispatch, _getState, paymentMethods, ui, mode, _ref3, showSubmitButton;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              payload = _ref.payload;
              getState = _ref2.getState, dispatch = _ref2.dispatch;
              _getState = getState(), paymentMethods = _getState.mopOnFile.paymentMethods, ui = _getState.config.ui;
              mode = payload.mode;
              _ref3 = ui, showSubmitButton = _ref3.showSubmitButton;
              doFireStatusUpdate([{
                status: StatusTypes.INFO,
                command: SharedCommandNames.APP_MODE_CHANGED,
                payload: {
                  component: Component.APP_MODULE_LOGIC,
                  data: {
                    appMode: mode
                  }
                }
              }]);
              if (mode === AppMode.ADD || mode === AppMode.EDIT) {
                if (paymentMethods.length > 0 || showSubmitButton) {
                  doFireStatusUpdate([{
                    status: StatusTypes.INFO,
                    command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD_DISABLED,
                    payload: {
                      component: Component.APP_MODULE_LOGIC
                    }
                  }]);
                  dispatch(setIsFetchPaymentMethodEnabled({
                    isFetchPaymentMethodEnabled: false
                  }));
                }
              } else {
                doFireStatusUpdate([{
                  status: StatusTypes.INFO,
                  command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD_ENABLED,
                  payload: {
                    component: Component.APP_MODULE_LOGIC
                  }
                }]);
                dispatch(setIsFetchPaymentMethodEnabled({
                  isFetchPaymentMethodEnabled: true
                }));
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function effect(_x, _x2) {
        return _effect.apply(this, arguments);
      }
      return effect;
    }()
  });
};
export default [setAppModeListener];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/AppModeState/AppModeState.listener.js
// module id = 4375
// module chunks = 11